
<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseEdit from '@shared_components/base_edit.vue';

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(loadEntry) {
      this.originalEntry = loadEntry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CUSTOMER_CULTURE_QUERY,
          fetchPolicy: "no-cache",
        })
        .then(response => {
          // this.editableEntry = response.data.accountContext.customerCulture;
          this.editableEntry.validations = response.data.accountContext.customerCulture.validations;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(customerCulture) {
      this.pageLoading = true;
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(customerCulture, this.editableEntry.validations);
      // console.log(filtered, filtered);
      this.$apollo
        .mutate({
          mutation: UPDATE_CUSTOMER_CULTURE_MUTATION,
          variables: {
            input: filtered,
          }
        })
        .then(response => {
          var errors = response.data.updateCustomerCulture.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    setObjectsFromIds: function(){
      this.editableEntry.harvest = this.extraData.accountContext.allHarvests.filter( (item)=> item.id == this.editableEntry.harvestId )[0];
      // console.log(this.entry.harvest);
      this.editableEntry.culture = this.extraData.accountContext.allCultures.filter( (item)=> item.id == this.editableEntry.cultureId )[0];
      this.editableEntry.plantedUnit = this.extraData.globalContext.allCustomerUnits.filter( (item)=> item.id == this.editableEntry.plantedUnitId )[0];
      // console.log(this.entry.harvest);
    },
    updateEntry: function() {
      this.setObjectsFromIds();
      if (this.$refs.form.isFormValid()){
        this.pageLoading = true;
        Object.assign(this.originalEntry, this.editableEntry);
        this.pageLoading = false;
        this.$refs.baseEdit.closeDialog();
        this.$emit("entry-updated", this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_CUSTOMER_CULTURE_QUERY = gql `
  query{
    accountContext{
      customerCulture {
        id
        harvestId
        harvest{
          id
          name
        }
        cultureId
        culture{
          id
          name
        }
        plantedUnitId
        plantedUnit{
          id
          name
        }
        plantedArea
        globalUnitId
        globalUnit{
          id
          name
        }
        globalArea
        irrigatedUnitId
        irrigatedUnit{
          id
          name
        }
        irrigatedArea
        producedUnitId
        producedUnit{
          id
          name
        }
        produced
        isRented
        technicalLevel
        rentedQuantity
        validations
      }
      technicalLevels
      allHarvests{
        id
        name
      }
      allCultures{
        id
        name
      } 
    }
    globalContext{
      allCustomerUnits{
        id
        name
      }
    }
  }
`;

</script>

<style scoped></style>

